import { Component, OnInit, Injectable } from '@angular/core';
import { VoicemailService } from 'src/app/services/voicemail/voicemail.service';
import { environment } from 'src/environments/environment';
import { Guid } from 'guid-typescript';
import { Lambda } from 'aws-sdk';
import * as RecordRTC from 'recordrtc';
import { WaveFile } from 'wavefile';
import { integer } from 'aws-sdk/clients/cloudfront';
import { catchError } from 'rxjs/operators';
import { bool } from 'aws-sdk/clients/signer';
import { Validators, FormControl, FormGroup } from '@angular/forms';


@Component({
  selector: 'app-voice-manager',
  templateUrl: './voice-manager.component.html',
  styleUrls: ['./voice-manager.component.css']
})
export class VoicemailManagerComponent implements OnInit {
  greetings = [];
  touchedGreetings= [];
  lambdaMessage = "";
  lambdaError = false;
  formValid = false;
  bluePrint = {"active": false, "text":""};
  state: string = "main"
  recordingStatus: string = "not recording"
  recording: boolean
  recordingItem: any
  recordingPresent: boolean
  recordingPresentLocal: boolean
  recordingItemEnabled: string = "inactive"
  textVoicemailSaved: boolean = false
  RecordingVoicemailSaved: boolean = false
  playerUrl: any
  keyS3: any
  key: any
  // bucket: any
  newGreeting: boolean = false
  previewPlay: boolean = true
  audioPlayer: any
  // greeting properties 
  enabledGreeting: any
  tempAudioDescription: string
  tempDescription: string
  tempContent: string
  greetingId: any
  type: string
  description: any
  content: any
  status: boolean
  keyTTS: any
  username: any
  //  Voicemail Delegation 
  deliveryEmail: any
  encryptVoicemail: any
  transcribeVoicemail: any
  enabled: any
  phoneNumber: any
  email: any
  cctranscriptValid:bool = true
  ccSaved: bool = false
  VoiceMailSaved: bool = false
  cctranscript: any
  userProfile: any 
  invalidUser: bool = false
  agentName: any
  loadingAgent: any = false
  invalidEmail: any = false
  VMSaved:bool = false
  VMEnabled: bool = false
  VMDisabled: bool = false

  
  alternateEmail = "";
  voicemailEnabled: boolean 

  data: any = [];
  
  recorder:any;
  url:any;
  error:any;
  processedRecording: any;
  audioURL: string = "";
  selectedRecording: any = null;
  recordings: any[] = [];
  recordingFile: any;
  isplaying: any = false

  AgentForm= new FormGroup({
    agentUsername: new FormControl('', Validators.required)
  })

  recordingTimer: any = 0;
  timer: any;
  timerDate: any;

  constructor(
    private voicemailService:VoicemailService
    ) { }

  ngOnInit(): void {
    this.timerDate = new Date(this.recordingTimer * 1000).toISOString().substr(14, 5);
  }

  agentEmailValidation(email){
     if ((email.includes("@")))
      {
        this.invalidEmail = false
        this.voicemailProfileSearch(email)
      }
     else 
      {
        this.invalidEmail = true
        this.invalidUser = false
      }
  }

  voicemailProfileSearch(profile){
    try {
      this.loadingAgent = true
      this.data = []
      this.voicemailService.userNameSearch(profile).then((response:any) => {
      console.log("Agent Name", response);
      if (response != null && response.status !== 404) {
        this.username = profile
        console.log(this.username)
        this.getGreeting()
        this.getUserEnabled();
        this.invalidUser = false
        this.agentName = response 
        console.log("works", this.agentName)
        this.loadingAgent = false
      }
      else
      
      {
        this.invalidUser = true
        this.loadingAgent = false
      }
      
      })
      
    } catch (error) {
      console.error(error);
    }
  }

  voicemailDelegation(){
    try {
      this.voicemailService.getAgentVoicemailConfig(this.username).then((response:any) => {
      console.log("User Config", response);
      const re = /^[A-Za-z0-9_.-.]+@[A-Za-z]{6}\.[A-Za-z]{3}(,\s[A-Za-z0-9.]+@[A-Za-z]{6}\.[A-Za-z]{3})*$/;
      if((!re.test(this.cctranscript)) && this.cctranscript != ""){
        this.cctranscriptValid = false
        setTimeout(() => {
          this.cctranscriptValid = true
          return;
        }, 6000)
        return;
      }
      if (response.status === 200 && this.cctranscriptValid != false) {
        this.cctranscriptValid = true
        let vmConfig = response.Voicemail
        vmConfig.ccField = this.cctranscript
        this.voicemailService.putAgentVoicemailConfig(this.username, vmConfig).then((response:any) => 
        {
        this.ccSaved = true
        console.log("Put Config Successful", response);
        setTimeout(() => {
          this.ccSaved = false
          return;
        }, 6000)
        })
      }
     }) 
    } catch (error) {
      console.error(error);
    }
    
  }




  // stopPreview(){
  //   let player: any = document.getElementById('audio-layer');
  //   player.pause()
  //   this.previewPlay = false
  // }

  


  getUserEnabled(){
    try {
      console.log(this.data)
      this.voicemailService.getUserDataEnabled(this.username).then((response:any) => {
      console.log("User Data", response.greetingId);
      this.enabledGreeting = response.greetingId})
    } catch (error) {
      console.error(error);
    }
    
  }

  deleteGreeting() {
    try {
      console.log(this.greetingId)
      this.voicemailService.deleteUserGreetings(this.greetingId).then((response:any) => {
      console.log("greeting deleted", response)
      if (response.status === 200) {
        this.getGreeting();
        this.displayVoicemailPage('main');
      }
      else {
        console.log("error cannot delete")
      }
    }
      )} catch (error) {
      console.error(error);
    }
    
  }

  greetingDisabled(){
  try {
    // this.username = this.amazonConnectService.getAgentUserName();
    this.greetingId = 'default'
    console.log("Greeting Status", this.recordingItemEnabled);
    this.recordingItemEnabled = "inactive"
    this.voicemailService.enableUserGreetings(this.username, this.greetingId).then((response:any) => {
    console.log("greeting enabled", response);
    this.VMDisabled = true
    setTimeout(() => {
      this.VMDisabled = false
      return;
    }, 6000)
  });
  } catch (error) {
    console.error(error);
  }
  }

  greetingEnabled() {
    try {
      // this.username = this.amazonConnectService.getAgentUserName();
      console.log("Greeting Status", this.recordingItemEnabled);
      this.recordingItemEnabled = "active"
      this.voicemailService.enableUserGreetings(this.username, this.greetingId).then((response:any) => {
      console.log("greeting enabled", response);
      this.VMEnabled = true
      setTimeout(() => {
        this.VMEnabled = false
        return;
      }, 6000)
    });
    } catch (error) {
      console.error(error);
    }
    
  }

  putGreetingTts() {
    try {
      if(this.newGreeting === true){
        this.greetingId = this.getGUID()
      }
      console.log(this.greetingId)
      this.description = document.getElementById('name')
      this.content = document.getElementById('content')
      console.log(this.greetingId)
      console.log(this.content)
      console.log(this.description)
    } catch (error) {
      console.error(error);
    }
    
  }

  getGreeting() {
    try {
      this.voicemailService.getUserGreetings(this.username).then((response:any) => {
      console.log("greetings fetched", response);
      console.log(response.status)
      this.data = response.data
    });
    } catch (error) {
      console.error(error);
    }
    
  }

  displayVoicemailPage(state: string){
    if(state === 'tts') {
      this.state = state;  
      this.type = "tts"
      this.newGreeting = true
    }
    if(state === 'recording') {
      this.state = state;  
      this.type = "recording"
      this.newGreeting = true
    }
    if(state === 'main') {
      this.state = state;  
      this.type = "tts"
      this.newGreeting = false
    }
  
    
    console.log("Voicemail Display", this.state);
  } 
 
  recordingState(recordingStatus: string){
    this.recordingStatus = recordingStatus;  
  } 

  recordingAvailable(){
    this.recordingItem ? this.recordingPresent = true : this.recordingPresent = false;
  }

  

  initiateRecording() {
    console.log("Recording Status", this.recordingStatus);
    this.url = null;
    this.timer = setInterval(() => {
      this.recordingTimer = this.recordingTimer + 1;
      this.timerDate = new Date(this.recordingTimer * 1000).toISOString().substr(14, 5);
    }, 1000);
    this.recording = true;
    let mediaConstraints = {
      audio: true
    };
    this.recordingStatus = "recording"
    this.recordingPresent = false
    navigator.mediaDevices.getUserMedia(mediaConstraints).then(
      this.successCallback.bind(this), 
      this.errorCallback.bind(this));
  }

  stopRecording() {
    console.log("Recording Status", this.recordingStatus);
    this.recording = false;
    this.recordingStatus = "not recording"
    this.recordingPresentLocal = true
    this.recorder.stopRecording(this.processRecording.bind(this));
    if(this.timer){
      clearInterval(this.timer);
    }
    this.recordingTimer = 0;
    this.timerDate = new Date(this.recordingTimer * 1000).toISOString().substr(14, 5);
  }

  deleteRecording() {
    this.recordingPresent = false

  }

  deleteLocalRecording() {
    this.recordingPresentLocal = false
    let player: any = document.getElementById('audio-layer');
    player.src = null
    this.audioPlayer = player.src
  }

  async saveLocalRecording() {
    try {
      this.RecordingVoicemailSaved = true
      
    if(this.greetingId === ""){
      this.greetingId = this.getGUID()
      // this.username = this.amazonConnectService.getAgentUserName();
      this.keyS3 = this.voicemailService.generateKey(this.greetingId, this.username)
      this.content = this.voicemailService.generateContent(this.keyS3)
      console.log('S3 key', this.keyS3)
      console.log('Content', this.content)
    }
    else{
      this.greetingId = this.greetingId
      // this.username = this.amazonConnectService.getAgentUserName();
      this.keyS3 = this.voicemailService.generateKey(this.greetingId, this.username)
      this.content = this.voicemailService.generateContent(this.keyS3)
      console.log('S3 key', this.keyS3)
    }
    // console.log("THIS IS THE KEY", this.keyS3)
    this.newGreeting = false
    this.recordingPresentLocal = false
    this.description = this.tempAudioDescription
    this.type = "audio"
    console.log(this.content)
    console.log(this.description)
    console.log(this.newGreeting)
    this.voicemailService.storeWav(this.processedRecording, this.keyS3, this.voicemailService.bucket).then((response:any) => {
      console.log("storeWaveResponse: ", response);
      if (response.status === 200) {
        this.voicemailService.putUserGreetings(this.username, this.greetingId, this.type, this.content, this.description).then((response:any) => {
          this.VMSaved = true
          setTimeout(() => {
            this.VMSaved = false
            return;
          }, 6000)
          console.log("Audio recording saved", response);
    });
      }
     });
 
    
    } catch (error) {
      
    }
    
    
    
  }

  saveRecordingTTS(){
    try {
      this.textVoicemailSaved = true
    if(this.greetingId === ""){
      this.greetingId = this.getGUID()
    }
    else{
      this.greetingId = this.greetingId
    }
    this.description = this.tempDescription
    this.content = this.tempContent
    this.newGreeting = false
    this.type = "tts"
    console.log(this.greetingId)
    // console.log(this.content)
    // console.log(this.description)
    // console.log(this.newGreeting)
    this.voicemailService.putUserGreetings(this.username, this.greetingId, this.type, this.content, this.description).then((response:any) => {
      this.VMSaved = true
      setTimeout(() => {
        this.VMSaved = false
        return;
      }, 6000)
      console.log("TTS recording saved", response);
    });
    } catch (error) {
      
    }
    
  }

  selectedGreeting(greetingId){
    this.newGreeting = false
    for (let i in this.data){  
      if (greetingId === this.data[i].greetingId){
        console.log(this.newGreeting)
        this.greetingId = this.data[i].greetingId
        this.content = this.data[i].content
        this.type = this.data[i].type
        this.description = this.data[i].description
        this.tempContent = this.data[i].content
        if (this.type === 'tts') {
          this.displayVoicemailPage('tts')
          this.newGreeting = false
        }
        else if (this.type === 'audio') {
          this.displayVoicemailPage('recording')
          this.getWavfile();
          this.newGreeting = false
      }
        
        }}}

  selectedGreetingPreview(greetingId){
    this.newGreeting = false
    for (let i in this.data){  
      if (greetingId === this.data[i].greetingId){
        this.greetingId = this.data[i].greetingId
        this.content = this.data[i].content
        this.type = this.data[i].type
        this.description = this.data[i].description
        this.username = this.data[i].username
        this.tempContent = this.data[i].content
        // console.log(this.content)
        // console.log(this.description)
        // console.log(this.greetingId)
        // console.log(this.username)
        }}
      if(this.type === 'audio')
        this.playPreview();
        else {
          this.playPreviewTTS(this.content)
        }
      }
      
  playPreview(){
    this.getWavfile().then(
      (response:any) => {
        let player: any = document.getElementById('audio-layer');
        player.play();
        this.previewPlay = true
        this.isPlaying(player)
        console.log("Player should be playing")
      }
    )
  }

  isPlaying(player)  {
    if (player.duration > 0 && !player.paused) {

      this.isplaying = true
  
  } else {
  
      this.isplaying = false
  
  }}
  
  stopPreview(){
    let player: any = document.getElementById('audio-layer');
    player.stop()
    this.isPlaying(player)
  }

  playPreviewTTS(content){
    if (content === undefined) {
    console.log('No content')
    return
    }
    else
    console.log(content)
    this.voicemailService.generatePollyVoice(content).then((response:any) => {
      console.log("Generating", response);
    this.keyTTS = response.key 
    this.getWavfileTTS().then(
      (response:any) => {
        let player: any = document.getElementById('audio-layer');
        player.play();
        this.previewPlay = true
        console.log("Player should be playing")
      }
    )
    })

   
  }

  getWavfile(){
    console.log('audio wav')
    return new Promise<any>((resolve) =>{
    this.voicemailService.bucket = this.content.split('/')[0]
    console.log('Bucket', this.voicemailService.bucket)
    this.key = this.content.split('/')[1] + '/' + this.content.split('/')[2] + '/' + this.content.split('/')[3]
    console.log('THIS KEY', this.key)
    this.voicemailService.getWav(this.voicemailService.bucket, this.key).then((response:any) => {
      console.log("getWave ", response);
      let player: any = document.getElementById('audio-layer');
      console.log(player)
      player.src = response.url
      this.audioPlayer = player.src
      console.log(this.content)
      console.log(response.url)
      resolve("Resolve")
      });
    })
  }
    
  getWavfileTTS(){
    console.log('TTS wav')
    return new Promise<any>((resolve) =>{
    this.voicemailService.bucket = environment.audioS3BucketDomain.split('/')[0]
    console.log('Bucket', this.voicemailService.bucket)
    this.key = 'temporary/' + this.keyTTS
    console.log('THIS KEY', this.keyTTS)
    this.voicemailService.getWav(this.voicemailService.bucket, this.keyTTS).then((response:any) => {
      console.log("getWave ", response);
      let player: any = document.getElementById('audio-layer');
      player.src = response.url
      this.audioPlayer = player.src
      console.log(this.content)
      console.log(response.url)
      resolve("Resolve")
      });
    })
  }

  clearForms(){
    console.log('Forms Cleared')
    this.content = ""
    this.type = ""
    this.description = ""
    this.greetingId= ""
    this.tempAudioDescription= ""
    this.tempContent=""
    this.tempDescription=""

    let player: any = document.getElementById('audio-layer');
    player.src = null
    
  }

 
  successCallback(stream:any) {
    var options = {
      type: "audio",
      mimeType: "audio/wav",
      numberOfAudioChannels: 1,
      desiredSampRate: 8000, 
      recorderType: RecordRTC.StereoAudioRecorder,
      ignoreMutedMedia: true,
    };
    console.log("recording config: ", options);
    this.recorder = new RecordRTC(stream, options);
    this.recorder.startRecording();
  }

  async processRecording() {
    let guid:string = Guid.create()['value'];
    guid = "test3";

    // set recorder to play raw recording
    this.recorder.getDataURL(url => {
      let player: any = document.getElementById('audio-layer');
      player.src = url
      this.audioPlayer = player.src
      this.playerUrl = url
    });
    
    // process the recording
    let blob:Blob = this.recorder.getBlob();
    let buffer = await blob.arrayBuffer();
    let wav = new WaveFile();
    wav.fromBuffer(new Uint8Array(buffer))
    wav.toMuLaw();
    this.processedRecording = wav.toBuffer();
  }

  errorCallback(error:any) {
    this.error = 'Can not play audio in your browser';
  }

  getGUID(){
    return Guid.create()['value'];
  }
}

